import config from '@config/'
import {
  ERROR_FILE_FORMAT_INVALIDIMAGE,
  ERROR_FILE_FORMAT_NOIMAGE,
  ERROR_FILE_FORMAT_WRONGMIME,
  ERROR_FILE_SIZE,
  WARNING_FILE_ASPECT_RATIO,
} from '@config/constants'

export const getFileByDropEvent = (e) => {
  if (e.dataTransfer.items) {
    const filtered = []

    for (let i = 0; i < e.dataTransfer.items.length; i++) {
      if (e.dataTransfer.items[i].kind === 'file') {
        filtered.push(e.dataTransfer.items[i])
      }
    }

    if (filtered.length) {
      return filtered[0].getAsFile()
    }
  } else {
    if (e.dataTransfer.files.length) {
      return e.dataTransfer.files[0]
    }
  }
  return false
}

export const getFileByInputUploadEvent = (e) => {
  return e.target?.files?.[0] || false
}

export const toKb = (bytes) => Math.round(bytes / 1024)

// eslint-disable-next-line no-unused-vars
export const validateFile = (serializedFile, _sujet) => {
  if (!serializedFile) {
    return [false, {}]
  }

  const { maxFileSizeBytes, allowedFileTypes } = config.files

  const { type: mime, size } = serializedFile

  if (size > maxFileSizeBytes) {
    return [
      ERROR_FILE_SIZE,
      { sTried: toKb(size), sMax: toKb(maxFileSizeBytes) },
    ]
  }

  const mimeSplit = mime.split('/')
  if (mimeSplit.length !== 2) {
    return [ERROR_FILE_FORMAT_WRONGMIME, {}]
  }

  if (mimeSplit[0] !== 'image' && mimeSplit[1] !== 'pdf') {
    return [ERROR_FILE_FORMAT_NOIMAGE, {}]
  }

  if (allowedFileTypes.indexOf(mimeSplit[1].toLowerCase()) < 0) {
    return [ERROR_FILE_FORMAT_INVALIDIMAGE, { s: allowedFileTypes.join(',') }]
  }

  return [true]
}

export const convertFileToSerializable = async (file) => {
  if (!file) {
    return false
  }
  const { name, type, size } = file

  const content = await toBase64(file)

  return {
    name,
    type,
    size,
    content,
  }
}

// https://stackoverflow.com/a/57272491
export const toBase64 = async (file) => {
  const convert = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })

  try {
    const result = await convert(file)
    return result
  } catch (error) {
    console.error(error)
    return false
  }
}

export const validateUploadImageDimensions = async (
  serializedFile,
  sujetDimensions
) => {
  const imgDimensions = await getImageDimenstionsByBase64(
    serializedFile.content
  )

  const toleranceImg = (imgDimensions.width / imgDimensions.height) * 1.2
  const toleranceSujet = sujetDimensions.width / sujetDimensions.height

  if (
    imgDimensions.width < sujetDimensions.width ||
    imgDimensions.height < sujetDimensions.height ||
    toleranceImg < toleranceSujet
  ) {
    return {
      success: false,
      type: WARNING_FILE_ASPECT_RATIO,
      warning: `Image is too small. It should be at least ${sujetDimensions.width}x${sujetDimensions.height}px`,
    }
  }

  return {
    success: true,
  }
}

export const getImageDimenstionsByBase64 = (base64) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
      })
    }
    img.onerror = reject
    img.src = base64
  })
}
